import fileTypes from 'constants/file-types';

import {
  trimArrayOfStrings,
  isAudioMime,
  isVideoMime,
  isImageMime,
  isDocumentMime
} from './';

export async function csvFileToArray(file) {

  const contents = await readFileAsText(file);

  const array = [];
  const lines = contents.split('\n');

  for (let line of lines) {

    const values = trimArrayOfStrings(line.split(','));

    array.push(values);

  }

  return array;

}

export async function readFileAsText(file) {

  const reader = new FileReader();

  return new Promise(function resolver(resolve, reject) {

    reader.onload = function onLoad(event) {
      const text = event.target.result;
      resolve(text);
    };

    reader.onerror = function onError(event) {
      reject(event);
    };

    reader.readAsText(file);

  });

}

export function isImage(file) {

  return isImageMime(file.type);

}

export function isVideo(file) {

  return isVideoMime(file.type);

}

export function isAudio(file) {

  return isAudioMime(file.type);

}

export function isDocument(file) {

  return isDocumentMime(file.type);

}

export function determineFileType(file) {

  if (isImage(file)) {
    return fileTypes.IMAGE;
  } else if (isVideo(file)) {
    return fileTypes.VIDEO;
  } else if (isAudio(file)) {
    return fileTypes.AUDIO;
  } else if (isDocument(file)) {
    return fileTypes.DOCUMENT;
  }

}

export async function downloadFile(filename, response) {

  const blob = await response.blob();

  const blobUrl = URL.createObjectURL(blob); // Create a URL for the Blob

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename; // Suggest a filename for the download

  document.body.appendChild(link);
  link.click(); // Programmatically click the link to start the download

  document.body.removeChild(link); // Clean up by removing the link
  URL.revokeObjectURL(blobUrl);

}